import React, {useState} from 'react';

import {AssignNewTaskModal} from 'app/tasks/components/AssignTaskModal';
import {gt} from 'app/utils/i18n';

import {UserSerializedType} from 'sweet-types';

interface Props {
  user: UserSerializedType;
  refreshData?: () => unknown;
}

export function AssignTaskToUserButton({
  refreshData,
  user,
}: Props): JSX.Element {
  const [show, setShow] = useState(false);

  return (
    <>
      <button onClick={() => setShow(true)} className="btn btn-sm alert-link">
        {gt('Assign Task')}
      </button>
      <AssignNewTaskModal
        show={show}
        taskData={{
          user_ids: [user.url],
        }}
        onToggle={() => setShow(false)}
        onAssignSuccess={() => refreshData?.()}
      />
    </>
  );
}
